import { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchChannelsRequest } from "../../store/Channels/action";
import { fetchChurchesRequest } from "../../store/Churches/actions";
import { AiOutlinePlus } from "react-icons/ai";
import avatar from "../../assets/icons/avatar.svg";
import Cross from "../../assets/icons/Cross.svg";
import Back from "../../assets/icons/Back.svg";
import { setIsNavigationAlertActiveAction } from "../../store/GlobalLoader/GlobalLoaderAction";
import Tab from "./Tab";
import Logo from '../../assets/icons/logo.svg'
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ConfirmToast from "./ConfirmToast";
function SearchBar({
  placeholder,
  value,
  onChangeSearchBar,
  showBackBtn = true,
  showChannelDropdown = false,
  channelOptions = [],
  selectedChannelId = "",
  onChangeChannel,
  showChurchDropdown = false,
  churchOptions = [],
  selectedChurchId = "",
  onChangeChurch,
  showMinistryDropdown = false,
  ministryOptions = [],
  selectedMinistryId = "",
  onChangeMinistry,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showMenu, setShowMenu] = useState(false);
  const { isAuthenticated, logout } = useAuth0();
  const { userInfo } = useSelector((state) => state.user);
  const displayName =
    [userInfo?.firstName, userInfo?.lastName].filter(Boolean).join(" ") ||
    userInfo?.name ||
    userInfo?.email ||
    "User";
  const { showNavigationAlert } = useSelector((state) => state.globalLoader);
  const isChannelAdmin = userInfo?.roleName === "Channel Admin";
  const isChurchAdmin = userInfo?.roleName === "Church Admin";
  const isMinistryAdmin = userInfo?.roleName === "Ministry Admin";
  const [internalOptions, setInternalOptions] = useState([]);
  const [internalSelected, setInternalSelected] = useState("");
  const [loadingChannels, setLoadingChannels] = useState(false);
  const [internalChurchOptions, setInternalChurchOptions] = useState([]);
  const [internalChurchSelected, setInternalChurchSelected] = useState("");
  const [loadingChurches, setLoadingChurches] = useState(false);
  const [internalMinistryOptions, setInternalMinistryOptions] = useState([]);
  const [internalMinistrySelected, setInternalMinistrySelected] = useState("");
  const [loadingMinistries, setLoadingMinistries] = useState(false);

  useEffect(() => {
    if (!isChannelAdmin || showChannelDropdown) return;
    try {
      const storedOptions = JSON.parse(localStorage.getItem("channelOptions") || "[]");
      setInternalOptions(Array.isArray(storedOptions) ? storedOptions : []);
      const storedChannel = JSON.parse(localStorage.getItem("channel") || "null");
      if (storedChannel?._id) {
        setInternalSelected(storedChannel._id);
      } else if (storedOptions?.length > 0) {
        setInternalSelected(storedOptions[0]._id || "");
        localStorage.setItem("channel", JSON.stringify(storedOptions[0]));
      }
    } catch (err) {
          }
  }, [isChannelAdmin, showChannelDropdown]);

  useEffect(() => {
    if (!isChannelAdmin || showChannelDropdown) return;
    if (loadingChannels) return;
    if (internalOptions?.length > 0) return;
    setLoadingChannels(true);
    dispatch(
      fetchChannelsRequest(
        { apiPayloadRequest: { typeofentity: "2" } },
        (res) => {
          setLoadingChannels(false);
          if (res?.type === 1 && Array.isArray(res?.data)) {
            setInternalOptions(res.data);
            localStorage.setItem("channelOptions", JSON.stringify(res.data));
            if (!internalSelected && res.data.length > 0) {
              const first = res.data[0];
              setInternalSelected(first?._id || "");
              localStorage.setItem("channel", JSON.stringify(first));
            }
          }
        }
      )
    );
  }, [dispatch, isChannelAdmin, showChannelDropdown, internalOptions, internalSelected, loadingChannels]);

  useEffect(() => {
    if (!isChurchAdmin || showChurchDropdown) return;
    try {
      const storedOptions = JSON.parse(localStorage.getItem("churchOptions") || "[]");
      setInternalChurchOptions(Array.isArray(storedOptions) ? storedOptions : []);
      const storedChurch = JSON.parse(localStorage.getItem("church") || "null");
      if (storedChurch?._id) {
        setInternalChurchSelected(storedChurch._id);
      } else if (storedOptions?.length > 0) {
        setInternalChurchSelected(storedOptions[0]._id || "");
        localStorage.setItem("church", JSON.stringify(storedOptions[0]));
      }
    } catch (err) {
          }
  }, [isChurchAdmin, showChurchDropdown]);

  useEffect(() => {
    if (!isMinistryAdmin || showMinistryDropdown) return;
    try {
      const storedOptions = JSON.parse(localStorage.getItem("ministryOptions") || "[]");
      setInternalMinistryOptions(Array.isArray(storedOptions) ? storedOptions : []);
      const storedMinistry = JSON.parse(localStorage.getItem("ministry") || "null");
      if (storedMinistry?._id) {
        setInternalMinistrySelected(storedMinistry._id);
      } else if (storedOptions?.length > 0) {
        setInternalMinistrySelected(storedOptions[0]._id || "");
        localStorage.setItem("ministry", JSON.stringify(storedOptions[0]));
      }
    } catch (err) {
          }
  }, [isMinistryAdmin, showMinistryDropdown]);

  useEffect(() => {
    if (!isChurchAdmin || showChurchDropdown) return;
    if (loadingChurches) return;
    if (internalChurchOptions?.length > 0) return;
    setLoadingChurches(true);
    dispatch(
      fetchChurchesRequest(
        {
          apiPayloadRequest: {
            typeofentity: "1",
          },
        },
        (res) => {
          setLoadingChurches(false);
          if (res?.type === 1 && Array.isArray(res?.data)) {
            setInternalChurchOptions(res.data);
            localStorage.setItem("churchOptions", JSON.stringify(res.data));
            if (!internalChurchSelected && res.data.length > 0) {
              const first = res.data[0];
              setInternalChurchSelected(first?._id || "");
              localStorage.setItem("church", JSON.stringify(first));
            }
          }
        }
      )
    );
  }, [
    dispatch,
    isChurchAdmin,
    showChurchDropdown,
    internalChurchOptions,
    internalChurchSelected,
    loadingChurches,
  ]);

  useEffect(() => {
    if (!isMinistryAdmin || showMinistryDropdown) return;
    if (loadingMinistries) return;
    if (internalMinistryOptions?.length > 0) return;
    setLoadingMinistries(true);
    dispatch(
      fetchChurchesRequest(
        {
          apiPayloadRequest: {
            typeofentity: "3",
          },
        },
        (res) => {
          setLoadingMinistries(false);
          if (res?.type === 1 && Array.isArray(res?.data)) {
            setInternalMinistryOptions(res.data);
            localStorage.setItem("ministryOptions", JSON.stringify(res.data));
            if (!internalMinistrySelected && res.data.length > 0) {
              const first = res.data[0];
              setInternalMinistrySelected(first?._id || "");
              localStorage.setItem("ministry", JSON.stringify(first));
            }
          }
        }
      )
    );
  }, [
    dispatch,
    isMinistryAdmin,
    showMinistryDropdown,
    internalMinistryOptions,
    internalMinistrySelected,
    loadingMinistries,
  ]);

  const onLogout = () => {
        localStorage.clear();
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  const onBack = () => {
    if (showNavigationAlert) {
      dispatch(setIsNavigationAlertActiveAction(true));
    } else {
      navigate(-1);
    }
  };

  const confirmChurchChange = (nextId, nextChurch) => {
    const churchTitle = nextChurch?.churchName || "Untitled Church";
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <ConfirmToast
            title="Change church?"
            message={`Are you sure you want to change to ${churchTitle}?`}
            deleteButtonText="Yes"
            onClose={onClose}
            onSuccess={() => {
              onClose();
              if (showChurchDropdown) {
                onChangeChurch?.(nextId);
                return;
              }
              setInternalChurchSelected(nextId);
              if (nextChurch) {
                localStorage.setItem("church", JSON.stringify(nextChurch));
                window.dispatchEvent(
                  new CustomEvent("church:change", { detail: nextChurch })
                );
              }
            }}
          />
        );
      },
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "!bg-gray-500 !bg-opacity-75",
    });
  };

  const confirmChannelChange = (nextId, nextChannel) => {
    const channelTitle =
      nextChannel?.channelName ||
      nextChannel?.churchName ||
      nextChannel?.name ||
      "Untitled Channel";
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <ConfirmToast
            title="Change channel?"
            message={`Are you sure you want to change to ${channelTitle}?`}
            deleteButtonText="Yes"
            onClose={onClose}
            onSuccess={() => {
              onClose();
              if (showChannelDropdown) {
                onChangeChannel?.(nextId);
                return;
              }
              setInternalSelected(nextId);
              if (nextChannel) {
                localStorage.setItem("channel", JSON.stringify(nextChannel));
                window.dispatchEvent(
                  new CustomEvent("channel:change", { detail: nextChannel })
                );
              }
            }}
          />
        );
      },
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "!bg-gray-500 !bg-opacity-75",
    });
  };

  const confirmMinistryChange = (nextId, nextMinistry) => {
    const ministryTitle =
      nextMinistry?.ministryName ||
      nextMinistry?.churchName ||
      nextMinistry?.name ||
      "Untitled Ministry";
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <ConfirmToast
            title="Change ministry?"
            message={`Are you sure you want to change to ${ministryTitle}?`}
            deleteButtonText="Yes"
            onClose={onClose}
            onSuccess={() => {
              onClose();
              if (showMinistryDropdown) {
                onChangeMinistry?.(nextId);
                return;
              }
              setInternalMinistrySelected(nextId);
              if (nextMinistry) {
                localStorage.setItem("ministry", JSON.stringify(nextMinistry));
                window.dispatchEvent(
                  new CustomEvent("ministry:change", { detail: nextMinistry })
                );
              }
            }}
          />
        );
      },
      closeOnEscape: true,
      closeOnClickOutside: true,
      overlayClassName: "!bg-gray-500 !bg-opacity-75",
    });
  };

  useEffect(() => {
    const eventHandler = (e) => {
      let headerSideNavbar = document.querySelector("#headerSideNavbar");
      if (headerSideNavbar && !headerSideNavbar?.contains(e.target)) {
        setShowMenu((preState) => !preState);
      }
    };
    document.addEventListener("mouseup", eventHandler);

    return () => document.removeEventListener("mouseup", eventHandler);
  }, []);

  return (
    <div className="w-full max-w-full min-w-0 flex items-center justify-between mb-4 overflow-visible">
     <div className="md:hidden"> {showBackBtn && <img className="cursor-pointer" src={Back} onClick={onBack} alt="back" />}</div>
      {/* <div className="relative"> */}
        {/* <BsSearch className="text-white fill-[#909090] absolute top-3 left-3" />
        <input
          className="pl-8 text-[#e3e3e3] text-sm placeholder:text-sm placeholder:text-[#909090] md:w-80 bg-[#131313] p-2 border border-greyishV2 border-opacity-50 rounded-lg"
          type="text"
          value={value}
          placeholder={placeholder}
          onChange={(e) => { if(onChangeSearchBar) onChangeSearchBar(e) }}
        /> */}
      {/* </div> */}
      <div className="hidden md:block">
        {/* <Tab/> */}
        {["Church Admin", "Channel Admin", "Ministry Admin"].includes(userInfo?.roleName) ? (
          <p className="text-lg text-white font-semibold">Welcome {displayName}</p>
        ) : (
          <img src={Logo} className="w-[50px] h-[50px]" />
        )}
      </div>
      <div className="flex min-w-0 items-center gap-4">
        {isChurchAdmin && (showChurchDropdown || isChurchAdmin) && (
          <div className="flex flex-col items-start">
            <label className="text-[11px] text-greyish mb-1">
              Select your church
            </label>
            <select
              className="bg-blackish p-2 text-white text-[13px] rounded-md h-10 border border-greyishV2 border-opacity-50 min-w-[220px]"
              value={showChurchDropdown ? selectedChurchId : internalChurchSelected}
              onChange={(e) => {
                const nextId = e.target.value;
                const currentId = showChurchDropdown
                  ? selectedChurchId
                  : internalChurchSelected;
                if (!nextId || nextId === currentId) return;
                const optionsList = showChurchDropdown
                  ? churchOptions
                  : internalChurchOptions;
                const next = optionsList.find((ch) => ch?._id === nextId);
                confirmChurchChange(nextId, next);
              }}
            >
              {(showChurchDropdown ? churchOptions : internalChurchOptions)?.length === 0 && (
                <option value="">No churches</option>
              )}
              {(showChurchDropdown ? churchOptions : internalChurchOptions)?.map((ch) => (
                <option key={ch?._id} value={ch?._id}>
                  {ch?.churchName || "Untitled Church"}
                </option>
              ))}
            </select>
          </div>
        )}
        {isMinistryAdmin && (showMinistryDropdown || isMinistryAdmin) && (
          <select
            className="bg-blackish p-2 text-white text-[13px] rounded-md h-10 border border-greyishV2 border-opacity-50 min-w-[220px]"
            value={showMinistryDropdown ? selectedMinistryId : internalMinistrySelected}
            onChange={(e) => {
              const nextId = e.target.value;
              const currentId = showMinistryDropdown
                ? selectedMinistryId
                : internalMinistrySelected;
              if (!nextId || nextId === currentId) return;
              const optionsList = showMinistryDropdown
                ? ministryOptions
                : internalMinistryOptions;
              const next = optionsList.find((ch) => ch?._id === nextId);
              confirmMinistryChange(nextId, next);
            }}
          >
            {(showMinistryDropdown ? ministryOptions : internalMinistryOptions)?.length === 0 && (
              <option value="">No ministries</option>
            )}
            {(showMinistryDropdown ? ministryOptions : internalMinistryOptions)?.map((ch) => (
              <option key={ch?._id} value={ch?._id}>
                {ch?.churchName || ch?.ministryName || "Untitled Ministry"}
              </option>
            ))}
          </select>
        )}
        {isChannelAdmin && (showChannelDropdown || isChannelAdmin) && (
          <select
            className="bg-blackish p-2 text-white text-[13px] rounded-md h-10 border border-greyishV2 border-opacity-50 min-w-[220px]"
            value={showChannelDropdown ? selectedChannelId : internalSelected}
            onChange={(e) => {
              const nextId = e.target.value;
              const currentId = showChannelDropdown ? selectedChannelId : internalSelected;
              if (!nextId || nextId === currentId) return;
              const optionsList = showChannelDropdown ? channelOptions : internalOptions;
              const next = optionsList.find((ch) => ch?._id === nextId);
              confirmChannelChange(nextId, next);
            }}
          >
            {(showChannelDropdown ? channelOptions : internalOptions)?.length === 0 && (
              <option value="">No channels</option>
            )}
            {(showChannelDropdown ? channelOptions : internalOptions)?.map((ch) => (
              <option key={ch?._id} value={ch?._id}>
                {ch?.churchName || ch?.channelName || "Untitled Channel"}
              </option>
            ))}
          </select>
        )}
        <div className="relative z-50">
          <img
            className="cursor-pointer w-[50px] h-[50px] object-cover object-top overflow-hidden rounded-full"
            onClick={() => setShowMenu((preState) => !preState)}
            src={userInfo?.profilePicUrl ?? avatar}
            alt=""
          />
          {showMenu && (
            <div
              className="absolute w-[380px] rounded-2xl bg-[#1F1F1F] right-0 top-16 shadow-xl p-6 z-[101]"
              id="headerSideNavbar"
            >
              <div className="flex justify-between">
                <p className="text-xs text-yellow-400 font-medium">Menu</p>
                <img
                  className="cursor-pointer"
                  src={Cross}
                  onClick={() => setShowMenu((preState) => !preState)}
                  alt="close-button"
                />
              </div>
              <ul className="pt-6 flex flex-col gap-4">
                <li
                  className="text font-normal text-white text-opacity-50 hover:text-opacity-100 cursor-pointer"
                  onClick={() => {
                    if (isAuthenticated) {
                      navigate("/profile");
                      setShowMenu((preState) => !preState);
                    } else {
                      localStorage.removeItem("token");
                      navigate("/login");
                    }
                  }}
                >
                  My Profile
                </li>
                <li
                  className="text font-normal text-white text-opacity-50 hover:text-opacity-100 cursor-pointer"
                  onClick={() => onLogout()}
                >
                  Logout
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchBar;
